import { FC } from 'react'
import { AccountLayout } from '../components/layout/AccountLayout'
import { MyDocumentsContent } from '../components/management/documents/MyDocumentsContent'

export const MyDocumentsPage: FC = () => (
  <AccountLayout>
    <MyDocumentsContent />
  </AccountLayout>
)

export default MyDocumentsPage
